export default "__VITE_ASSET__CloK7ipF__"